import { tripTableHeaders } from '../../../../trip.constants'
import {
  styled,
  TableCell,
  tableCellClasses,
  TableHead,
  TableRow,
} from '@mui/material'

const StyledTableCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== 'disabled',
})<{ disabled?: boolean }>(({ theme, disabled }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: disabled
      ? theme.palette.action.disabledBackground
      : theme.palette.secondary.light,
    color: disabled
      ? theme.palette.action.disabled
      : theme.palette.text.primary,
    padding: '4px 12px',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: 1.35,
    opacity: disabled ? 0.6 : 1,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: '4px 12px',
  },
}))

interface TripDetailsTableHeadersProps {
  isLandingPage?: boolean
  showRowActionsColumn?: boolean
  disabled?: boolean
}

const TripDetailsTableHeaders = ({
  isLandingPage = false,
  showRowActionsColumn = false,
  disabled = false,
}: TripDetailsTableHeadersProps) => {
  return (
    <TableHead>
      <TableRow>
        {tripTableHeaders.map((header) => {
          if (header.id === 'action' && isLandingPage) return null
          if (header.id === 'status' && !isLandingPage) return null

          const minWidths: Record<string, number> = {
            action: showRowActionsColumn ? 48 : 150,
            task: 140,
            order: 120,
            date: 150,
            company: 260,
            status: 150,
          }

          return (
            <StyledTableCell
              key={header.id}
              disabled={disabled}
              sx={{ minWidth: minWidths[header.id] }}
            >
              {header.label}
            </StyledTableCell>
          )
        })}
        {showRowActionsColumn && (
          <StyledTableCell disabled={disabled} sx={{ minWidth: 140 }} />
        )}
      </TableRow>
    </TableHead>
  )
}

export default TripDetailsTableHeaders
